import { HTTP_VERBS } from "../../enums";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3/acp/revert-to-draft";

export class Response {}
